import createRepository from './generic';

export default () => createRepository('key-value');
